export const COMPETITIONS_LIST_HEIGHT = 170 as const
export const COMPETITIONS_LIST_MAX_HEIGHT = 394 as const
export const COMPETITIONS_LIST_MIN_HEIGHT = 200 as const

export const COMPETITIONS_DIALOG_TEST_ID = {
  competitionsList: 'competitions-list',
  toggleCompetition: (value: string) => `toggle-${value}`,
  loadingState: 'loading-state',
  emptyState: 'empty-state',
  selectedSection: 'selected-section',
  availableSection: 'available-section',
  selectedCompetitionsList: 'selected-competitions-list',
  availableCompetitionsList: 'available-competitions-list',
  virtuosoMock: 'virtuoso-mock'
} as const
